export default __webpack_public_path__ + "static/devsecops-sicurezza-nello-sviluppo-a9b7b1761eeeb80ecf48402a00a5ba1f.png";